import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import Login from '@/views/Login'
import ChangePw from '@/views/ChangePw'
import Welcome from '@/views/Welcome'
import Layout from '@/views/layout/Layout'
import Role from '@/views/system/role/Role'
import RoleEdit from '@/views/system/role/RoleEdit'
// import Department from '@/views/system/department/Department'
// import DepartmentEdit from '@/views/system/department/DepartmentEdit'
import Account from '@/views/system/account/Account'
import AccountEdit from '@/views/system/account/AccountEdit'
import WorkTime from '@/views/system/workTime/List'
import WorkTimeEdit from '@/views/system/workTime/Edit'
import WorkType from '@/views/system/workType/List'
import WorkTypeEdit from '@/views/system/workType/Edit'
import SystemInfo from '@/views/system/SystemInfo'
import SystemAuth from '@/views/system/SystemAuth'
import RouterList from '@/views/device/router/List'
import RouterEdit from '@/views/device/router/edit'
import Collector from '@/views/device/collector/List'
import CollectorEdit from '@/views/device/collector/Edit'
import CollectorGroup from '@/views/device/group/List'
import CollectorGroupEdit from '@/views/device/group/Edit'
import People from '@/views/people/List'
import PeopleEdit from '@/views/people/Edit'
import Product from '@/views/product/List'
import ProductEdit from '@/views/product/Edit'
import Order from '@/views/order/List'
import OrderEdit from '@/views/order/Edit'
import Card from '@/views/card/List'
import CardEdit from '@/views/card/Edit'
// import Plan from '@/views/plan/List'
import ProductionPlan from '@/views/plan/production'
import OrderPlan from '@/views/plan/Order'
import CollectorPlan from '@/views/plan/Collector'
import Maintain from '@/views/maintain/List'
import MaintainEdit from '@/views/maintain/Edit'
import Setting from '@/views/setting/Setting'
import CollectorMonitor from '@/views/monitor/Collector'
import OrderMonitor from '@/views/monitor/Order'
import DeviceData from '@/views/data/device'
// import PeopleData from '@/views/data/people'
import OrderData from '@/views/data/order'
import Test from '@/views/Test'
import { Api } from '@/api'

Vue.use(Router)

export const staticRouterMap = [{
  name: 'Login',
  path: '/login',
  component: Login
}, {
  path: '/',
  name: 'Index',
  component: Layout,
  redirect: '/index',
  children: [{
    path: 'index',
    component: Welcome
  }]
}, {
  name: 'ChangePw',
  path: '/changePw',
  component: Layout,
  redirect: '/changePw/index',
  children: [{ name: 'index', path: 'index', component: ChangePw }]
}, {
  path: '/test',
  component: Test
}]

export const menueRouterMap = [{
  name: 'System',
  path: '/system',
  meta: {title: 'menu.system'},
  redirect: '/system/role',
  icon: 'ios-information',
  component: Layout,
  haveSubMenu: true,
  permission: 'system',
  children: [
    { name: 'Role', path: 'role', meta: {title: 'menu.system_management.Role'}, component: Role },
    { name: 'RoleEdit', path: 'role/:id', meta: {title: 'menu.system_management.RoleEdit'}, component: RoleEdit, hideMenu: true },
    // { name: 'Department', path: 'department', meta: {title: 'menu.system_management.Department'}, component: Department },
    // { name: 'DepartmentEdit', path: 'department/:id', meta: {title: 'menu.system_management.DepartmentEdit'}, component: DepartmentEdit, hideMenu: true },
    { name: 'Account', path: 'account', meta: {title: 'menu.system_management.Account'}, component: Account },
    { name: 'AccountEdit', path: 'account/:id', meta: {title: 'menu.system_management.AccountEdit'}, component: AccountEdit, hideMenu: true },
    { name: 'WorkTime', path: 'worktime', meta: {title: 'menu.system_management.WorkTime'}, component: WorkTime },
    { name: 'WorkTimeEdit', path: 'workTime/:id', meta: {title: 'menu.system_management.WorkTimeEdit'}, component: WorkTimeEdit, hideMenu: true },
    { name: 'WorkType', path: 'worktype', meta: {title: 'menu.system_management.WorkType'}, component: WorkType },
    { name: 'WorkTypeEdit', path: 'workType/:id', meta: {title: 'menu.system_management.WorkTypeEdit'}, component: WorkTypeEdit, hideMenu: true },
    { name: 'SystemInfo', path: 'systeminfo', meta: {title: 'menu.system_management.systeminfo'}, component: SystemInfo },
    // { name: 'ServerCfg', path: 'servercfg', meta: {title: '服务器配置管理'}, component: Welcome },
    { name: 'SystemAuth', path: 'systemauth', meta: {title: 'menu.system_management.SystemAuth'}, component: SystemAuth }
  ]
}, {
  name: 'Device',
  path: '/device',
  meta: {title: 'menu.Device'},
  redirect: '/device/router',
  icon: 'android-phone-portrait',
  component: Layout,
  haveSubMenu: true,
  permission: 'device',
  children: [
    { name: 'RouterList', path: 'router', meta: {title: 'menu.Device_management.RouterList'}, component: RouterList },
    { name: 'RouterEdit', path: 'router/:id', meta: {title: 'menu.Device_management.RouterEdit'}, component: RouterEdit, hideMenu: true },
    { name: 'Collector', path: 'collector', meta: {title: 'menu.Device_management.Collector'}, component: Collector },
    { name: 'CollectorEdit', path: 'collector/:id', meta: {title: 'menu.Device_management.CollectorEdit'}, component: CollectorEdit, hideMenu: true },
    { name: 'CollectorGroup', path: 'collectorgroup', meta: {title: 'menu.Device_management.CollectorGroup'}, component: CollectorGroup },
    { name: 'CollectorGroupEdit', path: 'collectorgroup/:id', meta: {title: 'menu.Device_management.CollectorGroupEdit'}, component: CollectorGroupEdit, hideMenu: true }
  ]
}, {
  name: 'Card',
  path: '/card',
  meta: {title: 'menu.Card'},
  redirect: '/card/list',
  icon: 'android-person',
  component: Layout,
  haveSubMenu: false,
  permission: 'card',
  children: [
    { name: 'CardList', path: 'list', meta: {title: 'menu.Card'}, component: Card },
    { name: 'CardEdit', path: 'edit/:id', meta: {title: 'menu.CardEdit'}, component: CardEdit, hideMenu: true }
  ]
}, {
  name: 'People',
  path: '/people',
  meta: {title: 'menu.People'},
  redirect: '/people/list',
  icon: 'android-person',
  component: Layout,
  haveSubMenu: false,
  permission: 'people',
  children: [
    { name: 'PeopleList', path: 'list', meta: {title: 'menu.People'}, component: People },
    { name: 'PeopleEdit', path: 'edit/:id', meta: {title: 'menu.PeopleEdit'}, component: PeopleEdit, hideMenu: true }
  ]
}, {
  name: 'Product',
  path: '/product',
  meta: {title: 'menu.Product'},
  redirect: '/product/list',
  icon: 'bookmark',
  component: Layout,
  haveSubMenu: false,
  permission: 'product',
  children: [
    { name: 'ProductList', path: 'list', meta: {title: 'menu.Product'}, component: Product },
    { name: 'ProductEdit', path: 'edit/:id', meta: {title: 'menu.ProductEdit'}, component: ProductEdit, hideMenu: true }
  ]
}, {
  name: 'Order',
  path: '/order',
  meta: {title: 'menu.Order'},
  redirect: '/order/list',
  icon: 'clipboard',
  component: Layout,
  haveSubMenu: false,
  permission: 'order',
  children: [
    { name: 'OrderList', path: 'list', meta: {title: 'menu.Order'}, component: Order },
    { name: 'OrderEdit', path: 'edit/:id', meta: {title: 'menu.OrderEdit'}, component: OrderEdit, hideMenu: true }
  ]
}, {
  name: 'Plan',
  path: '/plan',
  meta: {title: 'menu.Plan'},
  redirect: '/plan/production',
  icon: 'android-time',
  component: Layout,
  haveSubMenu: true,
  permission: 'production_plan',
  children: [
    { name: 'ProductionPlan', path: 'production', meta: {title: 'menu.Plan_Management.Production_plan'}, component: ProductionPlan },
    { name: 'CollectorPlan', path: 'collector', meta: {title: 'menu.Plan_Management.Production_management'}, component: CollectorPlan },
    { name: 'OrderPlan', path: 'order', meta: {title: 'menu.Plan_Management.Production_order'}, component: OrderPlan }
  ]
},
// {
//   name: 'Maintain',
//   path: '/maintain',
//   meta: {title: '维修管理'},
//   redirect: '/maintain/index',
//   icon: 'wrench',
//   component: Layout,
//   haveSubMenu: false,
//   children: [
//     { name: 'MaintainList', path: 'list', meta: {title: '维修管理'}, component: Maintain },
//     { name: 'MaintainEdit', path: 'edit/:id', meta: {title: '维修编辑'}, component: MaintainEdit, hideMenu: true }
//   ]
// },
{
  name: 'Monitor',
  path: '/monitor',
  meta: {title: 'menu.Monitor'},
  redirect: '/monitor/collector',
  icon: 'monitor',
  component: Layout,
  haveSubMenu: true,
  permission: 'monitor',
  children: [
    { name: 'CollectorMonitor', path: 'collector', meta: {title: 'menu.Monitor_Monitoring.Collector'}, component: CollectorMonitor },
    { name: 'OrderMonitor', path: 'order', meta: {title: 'menu.Monitor_Monitoring.Order'}, component: OrderMonitor }
  ]
}, {
  name: 'Data',
  path: '/data',
  meta: {title: 'menu.Data'},
  redirect: '/data/device',
  icon: 'stats-bars',
  component: Layout,
  haveSubMenu: true,
  permission: 'report_export',
  children: [
    { name: 'deviceData', path: 'device', meta: {title: 'menu.Data_output.device'}, component: DeviceData },
    // { name: 'peopleData', path: 'people', meta: {title: '人员统计'}, component: PeopleData },
    { name: 'OrderData', path: 'order', meta: {title: 'menu.Data_output.Order'}, component: OrderData },
    { name: 'MaintainList', path: 'list', meta: {title: 'menu.Data_output.MaintainList'}, component: Maintain },
    { name: 'MaintainEdit', path: 'edit/:id', meta: {title: 'menu.Data_output.MaintainEdit'}, component: MaintainEdit, hideMenu: true }
  ]
}, {
  name: 'Setting',
  path: '/setting',
  meta: {title: 'menu.Setting'},
  redirect: '/setting/index',
  icon: 'ios-gear',
  component: Layout,
  haveSubMenu: false,
  permission: 'setting',
  children: [{ name: 'SettingIndex', path: 'index', component: Setting }]
}]

let router = new Router({
  routes: staticRouterMap
})

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    if (localStorage.bearer) {
      next({
        path: '/'
      })
    } else {
      next()
    }
  } else {
    if (!localStorage.bearer) {
      next({ path: '/login' })
    } else {
      if (!store.getters.userInit) {
        Api.user.fetchUserInfo().then(res => {
          Api.account.get(res.user.id).then(res => {
            localStorage.language = res.account.language
          })
          store.dispatch('SetUser', res).then((premission) => {
            store.dispatch('GenerateMenus', premission).then(() => {
              router.addRoutes(menueRouterMap)
              next(to)
            })
          })
        })
      } else {
        next()
      }
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js